
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum ReplyType {
	Text = 0,
	Number = 1,
	Editor = 4,
	Approval = 6,
	Checkbox = 7,
	Select = 9,
	AddMultiple = 11,
	TrueFalse = 14
}
export namespace ReplyType {
	export function getKeys(): Map<ReplyType, string> {
		return new Map([[0, 'Text'], [1, 'Number'], [4, 'Editor'], [6, 'Approval'], [7, 'Checkbox'], [9, 'Select'], [11, 'AddMultiple'], [14, 'TrueFalse']]);
	}
}
